// TODO - Created this to allow for more sophisticated masking than react-input-mask allows, but it looks beforeMaskedValueChange() exists in the library that may be able to do the same thing. Look into this to see if we can remove this custom code

export function cleanseInput(event, state, changeValue, cleanse) {
  const field = event.target.getAttribute('name');

  const rawValue = event.target.value;
  const cleansedValue = cleanse(rawValue);

  changeValue(state, field, () => cleansedValue);
}

export function cleanseInt(value) {
  const cleansedInt = value.replace(/[^\d]/g, '');

  return cleansedInt;
}

export function cleanseDecimal(value) {
  const cleansedDecimal = value.replace(/[^0-9.]/g, '');

  return cleansedDecimal;
}
